import { render, staticRenderFns } from "./CandidateInterviewRoot.vue?vue&type=template&id=1352fe60"
import script from "./CandidateInterviewRoot.vue?vue&type=script&lang=ts"
export * from "./CandidateInterviewRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports